<script>
  import CheckBox from '../../../lib/components/CheckBox.svelte';
  import InputField from '../../../lib/components/InputField.svelte';
  import TextField from '../../../lib/components/TextField.svelte';
  import APIClient from '../../../state-charts/api-client';
  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import { compareStrings } from '../../../lib/utils';
  import session from '../../../lib/session';
  import { fly, fade } from 'svelte/transition';
  import Selector from '../../../lib/components/Selector.svelte';
  import { show_message } from '../../../lib/flash';
  import Switch from '../../../lib/components/Switch.svelte';
  import { show_tutorial_screen } from '../../../lib/tutorials';

  // component options  ------------------------------------------------------ //

  export let task_description;
  export let category_selector;
  export let category_name;
  export let team_code;
  export let is_team_code_valid;
  export let additional_info;
  export let worker_email = '';
  export let is_email_valid;
  export let public_teams;
  export let private_team_id;
  export let private_team_name;
  export let is_virtual;
  export let page_state;
  export let order;
  export let acc_ref;
  export let no_payment;
  export let additional_fields;
  export let next_tab_disabled = true;
  export let worker_invalid_team = false;
  export let is_team_selector_opened = false;
  export let has_main_init = false;
  export let init_counter;
  export let tab_history;

  // internal variables ------------------------------------------------------ //

  let field_blocks = [];
  let template_selector;
  let template_selector_items = [{ name: '...', val: '...' }];
  let category_selector_items = [];
  let private_team = null;
  let team_selector;
  let selected_team;
  let selected_worker;
  let selected_worker_str;
  let init_copy = false;
  let field_values_inited = false;
  let is_field_init_running = false;

  // utility functions -------------------------------------------------------- //

  let target_ord;
  let inv_tcode;
  let desc_req;
  let start_type;
  let task_type;
  let addteam;
  let addworker;
  let invworker;
  let textworker;
  let btn_prev;
  let btn_next;
  let teamname;
  let workername;
  let distancework_cbox;
  let label_accref;
  let invalid_additional_label;
  let new_order_required_information;
  let new_order_optional_information;
  let new_order_target_order;
  let rewatch_tutorial_label;

  let tooltips_target_task_desc;
  let tooltips_target_additional_info;

  let entertask;
  let pick;
  let addinfo;
  let addteamcode;
  let noteamsyet;
  let field_flag = false;
  let has_focused = false;

  // utility functions -------------------------------------------------------- //

  const rewatch_tutorial = async () => {
    await APIClient.put_tutorial({ tutorials: ['new_order'] });
    window.localStorage.setItem('WP.tutorial.new_order', 'true');
    show_tutorial_screen(true, 'new_order_o1', 400, 'orderer', true);
  };

  const is_any_team_selected = public_teams => {
    if (public_teams) {
      for (let i = 0; i < public_teams.length; i++) {
        if (public_teams[i].selected === true) {
          return true;
        }
      }
      return false;
    }
    return false;
  };

  const get_name_of_product = localized_names => {
    for (let [key, value] of Object.entries(localized_names)) {
      if (key.includes($session.language)) {
        return value;
      }
    }
  };

  const get_categories = () => {
    let merchant = $session.merchant;

    // for (let i = 0; i < merchants.length; i++) {
    //   if (merchants[i].merchant_uuid === $session.user.merchant_uuid) {

    for (let j = 0; j < merchant.products.length; j++) {
      let is_deleted = merchant.products[j].is_deleted;

      if (!is_deleted) {
        let no_payment = merchant.products[j].no_payment;
        let name = get_name_of_product(merchant.products[j].localized_names);
        let price = merchant.products[j].orderer_price.toFixed(2);
        let sign = merchant.currency_sign;
        let based_on = merchant.products[j].based_on;
        let new_item;

        // product_based_days
        // product_based_units
        // product_based_hours
        // product_based_months

        if (!no_payment) {
          let item_name;
          if (based_on === 'product_based_price') {
            item_name = `${name} (${sign})`;
          } else {
            if (based_on === 'product_based_days')
              item_name = `${name} (${t9n(
                TS.CREATE_ORDER_TASK_PRICE_DAY,
                `${price} ${sign}`
              )})`;
            if (based_on === 'product_based_units')
              item_name = `${name} (${t9n(
                TS.CREATE_ORDER_TASK_PRICE_UNIT,
                `${price} ${sign}`
              )})`;
            if (based_on === 'product_based_hours')
              item_name = `${name} (${t9n(
                TS.CREATE_ORDER_TASK_PRICE_HOUR,
                `${price} ${sign}`
              )})`;
            if (based_on === 'product_based_months')
              item_name = `${name} (${t9n(
                TS.CREATE_ORDER_TASK_PRICE_MONTH,
                `${price} ${sign}`
              )})`;
          }
          new_item = {
            name: item_name,
            raw_name: name,
            val: merchant.products[j].product_id,
            no_payment: no_payment,
          };
        } else {
          new_item = {
            name: `${name}`,
            raw_name: name,
            val: merchant.products[j].product_id,
            no_payment: no_payment,
          };
        }

        let tmp_name = new_item.name;
        let last_char_index = tmp_name.length - 1;
        if (tmp_name[last_char_index] === ' ') {
          new_item.name = tmp_name.slice(0, -1);
        }
        category_selector_items.push(new_item);
      }
    }
    //   }
    // }
    category_selector_items.sort((a, b) => {
      return compareStrings(a.name, b.name);
    });
  };

  const get_selected_team_string = name => {
    return t9n(TS.NEW_ORDER_DESC_TEAMNAME) + ' ' + name;
  };

  const get_selected_worker_string = name => {
    return name;
  };

  const set_no_payment = id => {
    let result = category_selector_items.find(element => element.val === id);
    if (!!result) {
      no_payment = result.no_payment;
      category_name = result.raw_name;
    }
  };

  const translate_texts = () => {
    target_ord = t9n(TS.NEW_ORDER_DESC_TARGET);
    inv_tcode = t9n(TS.NEW_ORDER_DESC_INV_TEAMCODE);
    desc_req = t9n(TS.NEW_ORDER_DESC_DESC_REQ);
    start_type = t9n(TS.NEW_ORDER_DESC_START);
    task_type = t9n(TS.NEW_ORDER_DESC_TASK_TYPE);
    addteam = t9n(TS.NEW_ORDER_DESC_ADDTEAM);
    addworker = t9n(TS.NEW_ORDER_DESC_ADDWORKER);
    invworker = t9n(TS.NEW_ORDER_DESC_INV_WORKER);
    textworker = t9n(TS.NEW_ORDER_DESC_TEXT_WORKER);
    btn_next = t9n(TS.TABLE_BUTTON_NEXT);

    entertask = t9n(TS.NEW_ORDER_LABEL_ENTER_TASK);
    pick = t9n(TS.NEW_ORDER_LABEL_PICK);
    addinfo = t9n(TS.NEW_ORDER_LABEL_ADD_INFO);
    addteamcode = t9n(TS.NEW_ORDER_LABEL_ADD_TEAM_CODE);
    noteamsyet = t9n(TS.NEW_ORDER_DESC_NOTEAMS);
    teamname = t9n(TS.NEW_ORDER_DESC_TEAMNAME);
    workername = t9n(TS.NEW_ORDER_DESC_WORKERNAME);
    distancework_cbox = t9n(TS.ORDERS_IS_VIRTUAL_CBOX);
    label_accref = t9n(TS.ORDER_ACC_REF);
    invalid_additional_label = t9n(TS.INVALID_INPUT);

    new_order_required_information = t9n(TS.NEW_ORDER_REQUIRED_INFORMATION);
    new_order_optional_information = t9n(TS.NEW_ORDER_OPTIONAL_INFORMATION);
    new_order_target_order = t9n(TS.NEW_ORDER_TARGET_ORDER);
    rewatch_tutorial_label = t9n(TS.TUTORIAL_REWATCH_TUTORIAL);
    tooltips_target_task_desc = t9n(TS.TOOLTIPS_TARGET_TASK_DESC);
    tooltips_target_additional_info = t9n(TS.TOOLTIPS_TARGET_ADDITIONAL_INFO);
  };

  const init_fields = () => {
    let required_fields = [
      {
        field_type: 'text',
        id: 'task-description',
        type: 'text',
        label: entertask,
        max_char: '160',
        value: task_description,
        validate: true,
        is_tooltip_default: false,
        tooltip_default_text: tooltips_target_task_desc,
        after_valid_text: null,
        disabled:
          page_state === 'edit' && !!order && order.applications.length > 0,
        validation_text: desc_req,
        width: '410px',
        valid: true,
        is_required: true,
        has_focused: false,
      },
      {
        field_type: 'selector',
        id: 'selector-category',
        label: pick,
        variant: 'outlined',
        validate: true,
        height: 320,
        valid: true,
        invalid_text: task_type,
        disabled:
          page_state === 'edit' && !!order && order.applications.length > 0,
        items: category_selector_items,
        value: category_selector,
        is_required: true,
        has_focused: false,
        input_value: null,
      },
    ];

    let optional_fields = [
      {
        field_type: 'textarea',
        id: 'additional-info',
        label: addinfo,
        value: additional_info,
        tooltip_default_text: tooltips_target_additional_info,
        max_chars: 20000,
        show_counter: false,
        height: '180px',
        width: '410px',
        has_focused: false,
      },
      {
        field_type: 'text',
        id: 'acc-ref',
        type: 'text',
        label: label_accref,
        max_char: '160',
        validate: false,
        valid: true,
        is_tooltip_default: false,
        after_valid_text: null,
        value: acc_ref,
        disabled:
          page_state === 'edit' && !!order && order.applications.length > 0,
        width: '410px',
        is_required: false,
        has_focused: false,
      },
    ];

    field_blocks = [
      {
        name: t9n(TS.NEW_ORDER_REQUIRED_INFORMATION),
        fields: required_fields,
      },
      {
        name: t9n(TS.NEW_ORDER_OPTIONAL_INFORMATION),
        fields: optional_fields,
      },
    ];

    if (additional_fields.length > 0) {
      let i = 0;
      additional_fields.forEach(e => {
        e.field_type_old = e.field_type;
        e.validation_text = t9n(TS.INVALID_INPUT);
        if (e.field_type === 'merchant_field_type_string') {
          e.field_type = 'text';
          e.type = 'text';
          if (!!e.max_length) {
            e.max_char = e.max_length.toString();
          }
        }
        if (e.field_type === 'merchant_field_type_integer') {
          e.field_type = 'text';
          e.type = 'number';
          if (!!e.max_length) {
            e.max_char = e.max_length.toString();
          }
        }
        if (e.field_type === 'merchant_field_type_float') {
          e.field_type = 'text';
          e.type = 'float';
          if (!!e.max_length) {
            e.max_char = e.max_length.toString();
          }
        }
        if (e.field_type === 'merchant_field_type_boolean') {
          e.field_type = 'checkbox';
        }
        e.width = '410px';
        e.validation_text = invalid_additional_label;
        e.validate = e.is_mandatory;
        e.is_required = e.is_mandatory;
        e.valid = true;
        e.after_valid_text = null;
        e.additional_id = i;
        e.has_focused = false;
        e.input_value = null;
        if (page_state !== 'copy' && page_state !== 'edit') {
          let length = tab_history.length;
          if (tab_history[length - 3] === 'init') {
            e.value = null;
          }
        }

        if (e.is_mandatory) {
          field_blocks[0].fields.push(e);
        } else {
          field_blocks[1].fields.push(e);
        }
        i++;
      });
      // let merchant_field_block = {
      //     name: t9n(TS.NEW_ORDER_MERCHANT_SPECIFIC),
      //     fields: merchant_fields
      // };
      // field_blocks.push(merchant_field_block);
    }

    field_flag = true;
  };

  const set_field_values = () => {
    task_description = field_blocks[0].fields[0].value;
    category_selector = field_blocks[0].fields[1].value;
    additional_info = field_blocks[1].fields[0].value;
    acc_ref = field_blocks[1].fields[1].value;

    if (additional_fields.length > 0) {
      if (field_blocks[0].fields.length >= 2) {
        let fields = field_blocks[0].fields;
        for (let i = 2; i < fields.length; i++) {
          if (!!fields[i].value) {
            if (
              fields[i].field_type_old === 'merchant_field_type_integer' ||
              fields[i].field_type_old === 'merchant_field_type_float'
            ) {
              additional_fields[fields[i].additional_id].value =
                fields[i].value;
            } else {
              additional_fields[fields[i].additional_id].value =
                fields[i].value;
            }
          }
        }
      }
      if (field_blocks[1].fields.length >= 2) {
        let fields = field_blocks[1].fields;
        for (let i = 2; i < fields.length; i++) {
          if (!!fields[i].value) {
            if (
              fields[i].field_type_old === 'merchant_field_type_integer' ||
              fields[i].field_type_old === 'merchant_field_type_float'
            ) {
              additional_fields[fields[i].additional_id].value =
                fields[i].value;
            } else {
              additional_fields[fields[i].additional_id].value =
                fields[i].value;
            }
          }
        }
      }
    }
  };

  const validate_fields = () => {
    if (field_blocks[0].fields[0].has_focused)
      field_blocks[0].fields[0].valid = !!task_description;
    if (field_blocks[0].fields[1].has_focused) {
      field_blocks[0].fields[1].valid = category_selector !== null;
    }
    if (additional_fields.length > 0) {
      if (field_blocks[0].fields.length > 2) {
        let fields = field_blocks[0].fields;
        for (let i = 2; i < fields.length; i++) {
          if (fields[i].has_focused) {
            fields[i].valid = !!fields[i].value;
          }
        }
      }
    }
  };

  const to_next = () => {
    window.next_tab();
  };

  const toggle_teams = () => {
    is_team_selector_opened = !is_team_selector_opened;
  };

  window.open_teams = () => {
    if (!!public_teams) {
      public_teams.forEach(e => {
        if (e.selected) is_team_selector_opened = true;
      });
    }
  };

  // reactive functions ------------------------------------------------------- //

  $: if (has_main_init && !field_flag) {
    get_categories();
    translate_texts();
    init_fields();
  }

  $: if (selected_worker)
    selected_worker_str = get_selected_worker_string(selected_worker);

  $: if (field_flag && field_blocks && has_main_init) {
    set_field_values();
    validate_fields();
    set_no_payment(category_selector);
  }

  $: if (
    has_main_init &&
    !!public_teams &&
    task_description &&
    !init_copy &&
    (page_state === 'copy' || page_state === 'edit')
  ) {
    // init_fields();
    init_copy = true;
    window.open_teams();
  }
</script>

<div id="description-card" class="center-mobile">
  {#each field_blocks as block, i}
    {#if i === 0}
      <div
        style="display: inline-flex; width: 100%; justify-content:
        space-between;">
        <p>{block.name}</p>
        <button
          id="rewatch_tutorial"
          style="margin-top: 9px; background-color: transparent; border: 0;
          cursor: pointer;"
          data-tooltip={t9n(TS.TOOLTIPS_REWATCH_NEW_ORDER_TUT)}
          on:click={async () => {
            await rewatch_tutorial();
          }}
          class="fade-in">
          <span
            style="color: var(--button_background_color);"
            class="material-icons">
            info
          </span>
        </button>
      </div>
    {:else}
      <p>{block.name}</p>
    {/if}
    <div class="flex">
      {#each block.fields as field, j}
        {#if field.field_type === 'text'}
          <!--{field.tooltip_default_text}-->
          <div
            data-tooltip={field.tooltip_default_text}
            class="responsive-input"
            style="margin-right: 30px">
            <InputField
              id={field.id}
              type={field.type}
              label={field.label}
              max_char={field.max_char}
              validate={field.validate}
              bind:value={field.value}
              disabled={field.disabled}
              validation_text={field.validation_text}
              after_valid_text={field.after_valid_text}
              valid={field.valid}
              is_tooltip_default={field.is_tooltip_default}
              tooltip_default_text={field.tooltip_default_text}
              is_required={field.is_required}
              bind:has_focused={field.has_focused} />
          </div>
        {/if}
        {#if field.field_type === 'selector'}
          <div
            class="selector-margin responsive-input"
            style="margin-bottom: 16px;">
            <Selector
              id={field.id}
              label={field.label}
              variant={field.variant}
              valid={field.valid}
              showed_elements="5"
              invalid_text={field.invalid_text}
              disabled={field.disabled}
              items={field.items}
              bind:has_focused={field.has_focused}
              is_required={field.is_required}
              bind:input_value={field.input_value}
              bind:value={field.value} />
          </div>
        {/if}
        {#if field.field_type === 'textarea'}
          <div
            data-tooltip={field.tooltip_default_text}
            class="responsive-input"
            style="margin-right: 30px; margin-bottom: 16px">
            <TextField
              bind:value={field.value}
              label={field.label}
              max_chars={field.max_chars}
              show_counter={field.show_counter}
              height={field.height} />
          </div>
        {/if}
        {#if field.field_type === 'select-checkbox'}
          <div
            class="checkbox-select-margin"
            style="width: 410px; margin-top: 10px; margin-bottom: 10px;">
            <button
              id="change_button"
              class="mdc-button mdc-button--outlined"
              style="width: 410px;"
              on:click|stopPropagation|preventDefault={() => toggle_teams()}>
              <span class="mdc-button__ripple" />
              {addteam}
            </button>

            {#if is_team_selector_opened}
              <div
                transition:fly={{ y: -50, duration: 250 }}
                style="margin-top: 20px; padding: 5px; overflow-y: auto;
                max-height: 172px; margin-bottom: 10px;">
                {#each field.items as item, i}
                  <div style="margin-bottom: 10px">
                    <Switch
                      id={'sw-int-' + i}
                      label={item.name}
                      bind:value={item.selected} />
                  </div>
                {/each}
              </div>
            {/if}
          </div>
        {/if}

        {#if field.field_type === 'checkbox'}
          <div class="virtual-cbox checkbox-margin">
            <CheckBox
              bind:value={field.value}
              id={field.id}
              disabled={field.disabled}
              label={field.label} />
          </div>
        {/if}
      {/each}
    </div>
  {/each}
</div>

<!-- Back + Next -->
<div style="display: flex; justify-content: flex-end">
  <!--    <button disabled class="mdc-button mdc-button&#45;&#45;unelevated margin-5" >-->
  <!--      <span class="mdc-button__ripple" />-->
  <!--      {btn_next}-->
  <!--    </button>-->

  <button
    id="next_button"
    on:click={to_next}
    disabled={next_tab_disabled}
    class="mdc-button mdc-button--unelevated margin-5">
    <span class="mdc-button__ripple" />
    {btn_next}
  </button>

</div>

<style>
  .virtual-cbox {
    margin-left: -10px;
    margin-top: 5px;
    min-width: 199px;
  }

  .mdc-text-field {
    width: 410px !important;
  }

  /* Desktop Mode
  *******************************************************/

  @media (min-width: 1025px) {
    .center-mobile {
      padding-left: 50px;
      padding-right: 50px;
    }

    .responsive-input {
      width: 410px;
    }

    .flex {
      width: 880px;
      display: flex;
      flex-wrap: wrap;
    }

    .mdc-layout-grid__cell--span-5 {
      margin-left: 10px;
    }

    .native-sel-width {
      width: 99.6% !important;
    }

    .mobile-margin {
      margin-left: 0;
    }

    .checkbox-margin {
      margin-right: 30px;
      width: 420px;
      margin-top: 15px;
    }

    .selector-margin {
      margin-right: 30px;
      margin-bottom: 16px;
    }

    .checkbox-select-margin {
      margin-right: 30px;
      margin-bottom: 16px;
    }
  }

  /* Tablet Mode
  *******************************************************/

  @media (min-width: 769px) and (max-width: 1024px) {
    .center-mobile {
      width: 55%;
      margin: auto;
      padding-left: 0px;
      padding-right: 50px;
    }

    .responsive-input {
      width: 410px;
    }

    .mdc-layout-grid__cell--span-5 {
      margin-left: 25px;
    }

    .native-sel-width {
      width: 100% !important;
    }

    .virtual-cbox {
      margin-left: 10px;
    }

    .flex {
      width: 410px;
      display: flex;
      flex-wrap: wrap;
    }

    .checkbox-margin {
      margin-left: -7px;
    }
  }

  /* Mobile Mode
        *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .select-box {
      width: 410px !important;
    }

    .center-mobile {
      width: 35%;
      margin: auto;
      padding-left: 0px;
      padding-right: 50px;
    }

    .responsive-input {
      width: 238px;
    }

    .mdc-layout-grid {
      margin-left: 10px;
    }

    .flex {
      width: 410px;
      display: flex;
      flex-wrap: wrap;
    }

    .mobile-margin {
      margin-left: 25px;
    }

    .mdc-layout-grid__cell--span-5 {
      margin-left: 25px;
    }

    .native-sel-width {
      width: 100% !important;
    }

    .virtual-cbox {
      margin-left: 20px;
    }

    .checkbox-margin {
      margin-left: -7px;
    }
  }
</style>
